module.exports = __webpack_public_path__ + "static/img/life-proposal1.5197a8da.png";